export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.25-1221.59",
  commitId: "19ae390cc420ffbc41995983c92965ec1dc8f6ac",
  commitTime: "2026-09-25T12:21:59.000Z",
});
